var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.brandName,attrs:{"id":"app","version":_vm.version}},[_c('router-view',{staticClass:"content-detail-view"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }